import { axiosDelete } from "../../../../../../packages/apiPackage/axiosRequest";
import ApiConstants from "../../../../../../utils/apiConstants";

async function DeleteSpeaker({ setBtnLoading, btnLoading, id }) {
    if (!btnLoading) {
        setBtnLoading(true);
        try {
            // console.log("id = ", id)
            await axiosDelete({
                endpoint: `${ApiConstants.DELETE_PE_SPEAKER}/${id}`,
            })
            // console.log("response = ", response);
            setBtnLoading(false);
            return true;
        } catch (error) {
            console.log("error = ", error)
            setBtnLoading(false);
            if (!error?.response) {
                console.log("No server response.");
                // console.log("Login credit Expired.\nPlease Login Again!!!");
            } else if (error.response?.status === 404 || error.response?.status === 401) {
                console.log("Server Error !!! Try Logging in again.");
            } else {
                console.log("Login credit Expired.\nPlease Login Again!!!");
            }
            return false;
        }
    }
}

export default DeleteSpeaker;